import { TagBadge } from '@/components/shared/TagBadge';
import type { WeddingEvent } from '@/lib/types';

interface NextCardProps {
  event: WeddingEvent | null;
  minutesUntil: number;
}

export function NextCard({ event, minutesUntil }: NextCardProps) {
  if (!event) {
    return (
      <div
        className="mx-4 p-3 rounded-xl flex items-center justify-center"
        style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          minHeight: '60px',
        }}
      >
        <p style={{ fontSize: '14px', color: 'var(--color-text-muted)' }}>
          No upcoming events
        </p>
      </div>
    );
  }

  const timeLabel = minutesUntil <= 0 ? 'starting now' : `in ${minutesUntil} min`;

  return (
    <div
      className="mx-4 p-3 rounded-xl"
      style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
      }}
    >
      {/* Top row */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <div
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: 'rgba(212,168,75,0.4)',
            }}
          />
          <span
            className="text-[11px] font-semibold uppercase tracking-widest"
            style={{ color: 'var(--color-text-muted)' }}
          >
            NEXT
          </span>
        </div>
        <TagBadge category={event.category} />
      </div>

      {/* Event name */}
      <p
        className="font-semibold leading-snug mb-1"
        style={{ fontSize: '17px', color: 'var(--color-text)' }}
      >
        {event.name}
      </p>

      {/* Location + time until */}
      <div className="flex items-center gap-1 flex-wrap">
        {event.location && (
          <>
            <span style={{ fontSize: '13px', color: 'var(--color-text-muted)' }}>
              {event.location}
            </span>
            <span style={{ fontSize: '13px', color: 'var(--color-text-muted)' }}> · </span>
          </>
        )}
        <span
          style={{ fontSize: '13px', color: 'var(--color-primary)', fontWeight: 600 }}
        >
          {timeLabel}
        </span>
      </div>
    </div>
  );
}
